'use client'
import React from 'react'

export const CodeIcon: React.FC = () => (
  <svg
    aria-hidden="true"
    className="icon"
    fill="none"
    focusable="false"
    height="20"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.76465 6L3.76465 10L7.76465 14" stroke="currentColor" />
    <path d="M12.2354 6L16.2354 10L12.2354 14" stroke="currentColor" />
  </svg>
)
